import React from 'react';
import Text from '../../../components/Text';
import Button from '../../../components/Button';

interface DeleteBranchModalProps {
    branchName: string;
    onConfirm: () => void;
    onCancel: () => void;
}

export const DeleteBranchModal: React.FC<DeleteBranchModalProps> = ({
    branchName,
    onConfirm,
    onCancel,
}) => {
    return (
        <div>
            <Text classes={'zr-mb-4'}>
                {`Branche „${branchName}“ wirklich löschen?`}
            </Text>
            <div className={'zr-d-flex zr-gap-2'}>
                <Button hierarchy="primary" text="Löschen" fn={onConfirm} />
                <Button hierarchy="secondary" text="Abbrechen" fn={onCancel} />
            </div>
        </div>
    );
};
